import { FolderSpecialOutlined } from "@material-ui/icons";
import { VirtualTenantsList } from "./VirtualTenantsList";
import { VirtualTenantCreate } from "./VirtualTenantCreate";
import { VirtualTenantEdit } from "./VirtualTenantEdit";

export default {
  icon: FolderSpecialOutlined,
  list: VirtualTenantsList,
  create: VirtualTenantCreate,
  edit: VirtualTenantEdit,
};
